export const getGoogleMapSource = (str) => {
    if (!str) return null;
    const strArray = str.split(" ");
    const srcStr = strArray.find(strItem => strItem.startsWith("src="));
    const src = srcStr.split("src=")[1];
    return JSON.parse(src);
}